import { render, staticRenderFns } from "./TravelEvents.vue?vue&type=template&id=e97e482e&"
import script from "./TravelEvents.vue?vue&type=script&lang=js&"
export * from "./TravelEvents.vue?vue&type=script&lang=js&"
import style0 from "./TravelEvents.vue?vue&type=style&index=0&id=e97e482e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports